import React, { useEffect, useState } from 'react'
import { Link, useSearchParams} from 'react-router-dom'
import Footer from '../../../Component/Footer/Footer'
import Navbar from '../Navbar/Navbar'
import { useGetClassByAgeAndGenderMutation } from '../../../Redux/Api/AuthApi'
import "./Details.css"
import { classes } from "../../../Data";

const Details = () => {
const [resData,setResData] = useState()
const [errMsg,setErrMsg] = useState()
const [searchParams] = useSearchParams();
const [filteredClasses, setFilteredClasses] = useState(classes);
const [searchTerm, setSearchTerm] = useState("");
const [selectedProgram, setSelectedProgram] = useState("all");
const [selectedAge, setSelectedAge] = useState("all");
const [selectedDay, setSelectedDay] = useState("all");
const [isFilterOpen, setIsFilterOpen] = useState(false);
 // Use the .get() method to retrieve specific value

const age = searchParams.get('ages');    
const gender = searchParams.get('gender'); //
const [getClassByAgeAndGender,{isLoading}] = useGetClassByAgeAndGenderMutation()

  // Extract unique programs, age groups, and days from data
  const programs = [
    "all",
    ...new Set(classes.map((c) => c.program).filter(Boolean)),
  ];
  const ageGroups = [
    "all",
    ...new Set(classes.map((c) => c.ageGroup).filter(Boolean)),
  ];
  const days = [
    "all",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
    useEffect(() => {
      let filtered = classes;
  
      // Filter by search term
      if (searchTerm) {
        filtered = filtered.filter(
          (classItem) =>
            classItem.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
            classItem.description
              ?.toLowerCase()
              .includes(searchTerm.toLowerCase())
        );
      }
  
      // Filter by program
      if (selectedProgram !== "all") {
        filtered = filtered.filter(
          (classItem) => classItem.program === selectedProgram
        );
      }
  
      // Filter by age group
      if (selectedAge !== "all") {
        filtered = filtered.filter(
          (classItem) => classItem.ageGroup === selectedAge
        );
      }
  
      // Filter by day
      if (selectedDay !== "all") {
        filtered = filtered.filter((classItem) =>
          classItem.day?.includes(selectedDay)
        );
      }
  
      setFilteredClasses(filtered);
    }, [searchTerm, selectedProgram, selectedAge, selectedDay]);

  const clearFilters = () => {
    setSearchTerm("");
    setSelectedProgram("all");
    setSelectedAge("all");
    setSelectedDay("all");
  };

  const getAgeBadgeColor = (ageGroup) => {
    if (ageGroup?.includes("1.5")) return "#10b981";
    if (ageGroup?.includes("3-5")) return "#3b82f6";
    if (ageGroup?.includes("5-16")) return "#8b5cf6";
    if (ageGroup?.includes("5+")) return "#f59e0b";
    return "#ef4444";
  };

  useEffect(()=>{
    async function fetchClass(){
      const getClass = await getClassByAgeAndGender({age,gender})
      //console.log(getClass)
      if(getClass?.data){
        setResData(getClass?.data?.data)
        console.log(getClass?.data?.data)
      }else{
        setErrMsg(getClass?.error?.data?.message)
      }
    }
    fetchClass()
  },[age,gender,getClassByAgeAndGender])

  return (
    <div className='kiga-classes-main'>
      <Navbar/>
      {isLoading && (
       <div><p>Iz Loading.....</p></div>  
      )}
      {/* Search and Filter Section */}
      <section className="kiga-classes-filter-section">
        <div className="kiga-classes-container">
          <div className="kiga-filter-header">
            <div className="kiga-search-box">
              <i className="fa-solid fa-search"></i>
              <input
                type="text"
                placeholder="Search classes..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <button
              className="kiga-filter-toggle"
              onClick={() => setIsFilterOpen(!isFilterOpen)}
            >
              <i className="fa-solid fa-sliders-h"></i>
              Filters
              <span
                className={`kiga-classes-arrow ${isFilterOpen ? "open" : ""}`}
              >
                ▼
              </span>
            </button>
          </div>

          <div className={`kiga-filters-panel ${isFilterOpen ? "open" : ""}`}>
            <div className="kiga-filter-group">
              <label>Program Type</label>
              <div className="kiga-filter-options">
                {programs?.map((program) => (
                  <button
                    key={program}
                    className={`kiga-filter-btn ${
                      selectedProgram === program ? "active" : ""
                    }`}
                    onClick={() => setSelectedProgram(program)}
                  >
                    {program === "all" ? "All Programs" : program}
                  </button>
                ))}
              </div>
            </div>

            <div className="kiga-filter-group">
              <label>Age Group</label>
              <div className="kiga-filter-options">
                {ageGroups?.map((age) => (
                  <button
                    key={age}
                    className={`kiga-filter-btn ${
                      selectedAge === age ? "active" : ""
                    }`}
                    onClick={() => setSelectedAge(age)}
                  >
                    {age === "all" ? "All Ages" : age}
                  </button>
                ))}
              </div>
            </div>

            <div className="kiga-filter-group">
              <label>Day of Week</label>
              <div className="kiga-filter-options">
                {days?.map((day) => (
                  <button
                    key={day}
                    className={`kiga-filter-btn ${
                      selectedDay === day ? "active" : ""
                    }`}
                    onClick={() => setSelectedDay(day)}
                  >
                    {day === "all" ? "All Days" : day}
                  </button>
                ))}
              </div>
            </div>

            {(selectedProgram !== "all" ||
              selectedAge !== "all" ||
              selectedDay !== "all" ||
              searchTerm) && (
              <button className="kiga-clear-filters" onClick={clearFilters}>
                <i className="fa-solid fa-times"></i>
                Clear All Filters
              </button>
            )}
          </div>
        </div>
      </section>

    {
      errMsg ? (
        <div><p>{errMsg}</p></div>
      ):(
    <section className='kiga-classes-section'>
      {
       resData?.isFiltered?.map((item,key)=>(
     <div className='kiga-classes-section-box' key={key}>
      <Link to={`/portal/booking/classes/DetailEnroll/${item?._id}`}>
        <div className='kiga-classes-section-box-image'>
          <img src={item?.image ? item?.image?.secure_url : null}alt='classes'/>
        </div>
      </Link>
      <Link to={`/portal/booking/classes/DetailEnroll/${item?._id}`}>
        <div className='kiga-classes-section-title'>
        <p>{item?.name}</p>
        </div>
      </Link>
      <div className='kiga-classes-section-schedule'>
        <div className='kiga-classes-section-schedule-date'>
          <p>{item?.date}</p>
        </div>
        <div className='kiga-schedule-activity'>
         <p >{item?.activity ? item?.activity : 'opened'}</p>
        </div>
      </div>
      <div className='kiga-classes-section-days'>
        {
          item?.days?.map((item,key)=>(
            <p key={key}>
              {item}
            </p>
          ))
        }
      </div>
     </div>
        ))
      }

    </section>
      )
    }
    <Footer/>
    </div>
  )
}

export default Details